export const plazos = {
    capital: {
        simple: '(7 días hábiles)',
        urgente: '(3 días hábiles)',
        express: '(1 día hábil)',
    },
    provincia: {
        simple: '(8 a 10 días hábiles)',
        urgente: '(2 a 4 días hábiles)',
        en_el_dia: '(1 día hábil)',
    },
}

